$(function(){
	$('a[href*=\\#]:not([href=\\#])').on('click',function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				if($(this).parents('.menuBox').length){
					setTimeout(function(){
						var targetOffset = $target.offset().top;
						$('html,body').animate({scrollTop: targetOffset}, 1000);
					},100);
				}else{
					var targetOffset = $target.offset().top;
					$('html,body').animate({scrollTop: targetOffset}, 1000);
				}
				return false;
			}
		}
	});

	$(window).scroll(function(){
		if($(window).scrollTop()  > $('#main .sec02').offset().top) {
			$('.fixLink').fadeIn();
		}else{
			$('.fixLink').fadeOut();
		}
	});
});

$(window).on('load',function(){
	$(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
		$('.animate,.fadeIn,.fadeIn-2,.clipShow').each(function(){
			var targetPosition = $(this).offset().top;
			if(topWindow > targetPosition - windowHeight + 100){
				$(this).addClass("on");
			}
		});
	}).trigger("scroll");
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){
		localLink = localLink.slice(localLink.indexOf("#")+1);
		if($('#'+localLink).length){
			setTimeout(function(){
				$('html,body').animate({scrollTop: $('#'+localLink).offset().top}, 500);
			},100);
		}
	}
});